module.exports = __webpack_public_path__ + "static/media/2.ff266c7b.jpg";